import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gallery" }

import GalleryImage from './components/GalleryImage.vue';
import GalleryThumbnails from './components/GalleryThumbnails.vue';
import {useStore} from './store';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GalleryImage),
    (_unref(store).images.length > 1)
      ? (_openBlock(), _createBlock(GalleryThumbnails, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})